import { loadingWeb3, web3Loaded, web3Unloaded, web3AccountLoaded, web3AccountUnloaded, currentTimestampLoaded } from "../actions/actions.js";
import { handleNewError } from "./errorInteractions";
import { setIntervalAsync } from "set-interval-async/fixed";
import { clearIntervalAsync } from "set-interval-async";
import Web3 from "web3";
import { init } from "./rootInteractions";
let currentTimestampUpdateInterval;
const FIFTEEN_SECONDS = 15000;

export const loadWeb3 = (web3, dispatch) => {
  if (web3) {
    dispatch(loadingWeb3());
    web3.eth.handleRevert = true;
    dispatch(web3Loaded(web3));
    return web3;
  } else {
    handleNewError({}, "Unable to load web3!", 1, dispatch, true);
  }
};

export const loadWeb3Account = async (web3, dispatch) => {
  try {
    const accounts = await web3.eth.getAccounts();
    dispatch(web3AccountLoaded(accounts[0]));
    return accounts[0];
  } catch (e) {
    handleNewError({}, "Unable to load account. Please login to your wallet.", 1, dispatch, true);
  }
};

export const unloadWeb3Account = async dispatch => {
  try {
    dispatch(web3Unloaded());
    dispatch(web3AccountUnloaded());
  } catch (e) {
    handleNewError({}, "Unable to unload web3 account. ", 1, dispatch, true);
  }
};

export const subscribeToAccountChange = async (provider, gammaContractsRegistry, uniswapAdapter, dispatch) => {
  window.ethereum.on("accountsChanged", async accounts => {
    // replace web3 on account change
    const web3 = new Web3(provider);
    loadWeb3(web3, dispatch);
    dispatch(web3AccountLoaded(accounts[0]));
    const networkId = await web3.eth.net.getId();
    init(web3, networkId, accounts[0], dispatch);
    // loadUserAccountDependantContracts(web3, gammaContractsRegistry, accounts[0], uniswapAdapter, dispatch);
  });
};

// todo: v1 this should be turned off..
export const subscribeToBlockchainTimestampChange = async (web3, dispatch) => {
  let block = await web3.eth.getBlock("latest");
  dispatch(currentTimestampLoaded(block.timestamp));
  currentTimestampUpdateInterval = setIntervalAsync(async () => {
    console.log("Call blockchain - getBlock latest");
    let block = await web3.eth.getBlock("latest");
    dispatch(currentTimestampLoaded(block.timestamp));
  }, FIFTEEN_SECONDS);
};

export const unsubscribeToBlockchainTimestampChange = async (web3, dispatch) => {
  if (currentTimestampUpdateInterval) {
    await clearIntervalAsync(currentTimestampUpdateInterval);
  }
};

export const subscribeToChainChange = () => {
  window.ethereum.on("chainChanged", chainId => {
    window.location.reload();
  });
};
